/**
 * 상점 통계 조회 폼데이터
 */
export class FormDataGetStats {
    /** 허브 또는 상점 타입 */
    resourceType = 'store';
    /** 통계 종류 (일별, 월별등..) */
    statsType = 'daily';
    /** 선택한 허브 아이디 */
    selectedHub = '';
    /** 선택한 상점 아이디 */
    selectedStore = 'ALL';
    /** 기간 */
    date = [];
    /** 발주 or 수주 */
    orderOrShare = 'order';
    /** 전체 or B2B */
    allOrB2b = 'all';
    /** 정렬방식 */
    sortType = 'resource';
    /** 요약 여부 */
    isSummary = false;
    constructor(data) {
        if (!data) {
            return;
        }
        // get set 없이 딱 필드만 있게 하기 위해 중간에 처리
        const cls = new FormDataGetStats();
        Object.getOwnPropertyNames(cls).forEach((it) => {
            const value = data[it];
            this[it] = value;
        });
    }
}
